var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconRetry24 = function SvgAIconRetry24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.395 16.8361C16.9882 20.6128 12.1706 22.045 8.09153 20.1966C4.01242 18.3481 1.91328 13.7814 3.16631 9.48192C4.41935 5.18239 8.64322 2.45852 13.0767 3.09092C15.7588 3.47349 18.0238 5.01394 19.395 7.16283",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9739 4.75L21.0003 8.72382L16.9954 8.75",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconRetry24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTE5LjM5NSAxNi44MzYxQzE2Ljk4ODIgMjAuNjEyOCAxMi4xNzA2IDIyLjA0NSA4LjA5MTUzIDIwLjE5NjZDNC4wMTI0MiAxOC4zNDgxIDEuOTEzMjggMTMuNzgxNCAzLjE2NjMxIDkuNDgxOTJDNC40MTkzNSA1LjE4MjM5IDguNjQzMjIgMi40NTg1MiAxMy4wNzY3IDMuMDkwOTJDMTUuNzU4OCAzLjQ3MzQ5IDE4LjAyMzggNS4wMTM5NCAxOS4zOTUgNy4xNjI4MyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMjAuOTczOSA0Ljc1TDIxLjAwMDMgOC43MjM4MkwxNi45OTU0IDguNzUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4K";